import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 Coreano Expresso™ (6 Tomi, 120+ pagine)',
  price: '27€'
}, {
  label: '🎁 Bonus #1: Dizionario Visivo K-Food: Mangia come a Seoul',
  price: 'GRATIS'
}, {
  label: '🎁 Bonus #2: Cheat-Sheet: 100 Frasi per il tuo IDOL',
  price: 'GRATIS'
}, {
  label: '🎁 Bonus #3: Seoul Express: Guida Turistica di Sopravvivenza',
  price: 'GRATIS'
}, {
  label: '🎁 Bonus #4: Flashcards Stampabili: Hangeul Flash-Master',
  price: 'GRATIS'
}, {
  label: '🎁 Bonus #5: Workbook di Scrittura: Il Mio Primo Diario Coreano',
  price: 'GRATIS'
}, {
  label: '🛡️ Garanzia di soddisfazione 7 giorni',
  price: 'INCLUSO'
}, {
  label: '♾️ Accesso a vita & aggiornamenti gratuiti',
  price: 'INCLUSO'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pagamento 100% Sicuro'
}, {
  icon: ZapIcon,
  label: 'Consegna Istantanea'
}, {
  icon: ShieldCheckIcon,
  label: 'Garanzia 7 giorni'
}, {
  icon: CreditCardIcon,
  label: 'Carta di Credito / Debito'
}];
export function ValueStack() {
  return <section id="value" aria-label="Riepilogo dell'offerta" className="border-y border-grape/10 bg-white/70" data-id="element-209" data-mp="1ohl4i33lvprg">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" style={{
      paddingTop: "14px"
    }} data-id="element-210" data-mp="236r0li75czv4">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-211" data-mp="1ycv98yle2b8x">
          🚀 Inizia a Leggere il Coreano in 60 minuti
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-212" data-mp="284j5dcsw4ggq">
          Leggi l'Hangeul, pronuncia correttamente e costruisci le tue prime vere frasi in coreano.
          Un solo pagamento, accesso illimitato, tutto pronto per iniziare oggi.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-213" data-mp="2h5qq0s2hhisc">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-214" data-mp="rq9gmhkqkppd">
            <span data-id="element-215" data-mp="2mtxq04oic6jc">Cosa è incluso</span>
            <span data-id="element-216" data-mp="2mv0fq9a3g2xo">Prezzo</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-217" data-mp="2rrh4n5p4albt">
              <span className="text-plum/80" data-id="element-218" data-mp="2vsasy06h2258">{r.label}</span>
              <span className={r.price.endsWith('€') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} data-id="element-219" data-mp="30tgo04nlu1hx">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-220" data-mp="3aqv1pwi58c6j">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "25px"
          }} data-id="element-221" data-mp="3fi3cowz4g5lt">
              Valore reale totale: <span className="text-plum/40 line-through" data-id="element-222" data-mp="3jjyc1vxhs8wy">54€</span>
            </span>
            <span className="text-grape-shine font-display text-5xl font-black leading-none sm:text-6xl" style={{
            fontSize: "80px",
            fontFamily: "Cinzel, serif",
            paddingTop: "8px",
            paddingBottom: "11px"
          }} data-id="element-223" data-mp="3oirqproim5yp">
              27€
            </span>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-224" data-mp="7gyatyfo0jv4">
              EUR · Pagamento unico
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-225" data-mp="3tndeie6hgrfv">
              Il pagamento sarà elaborato nella tua valuta locale.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-226" data-mp="3pnur9br6w49v">
          <CTAButton data-id="element-227" data-mp="q5lf4eq0p57n">Ottieni Coreano Expresso</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-228" data-mp="l7tqpuol0187">
          Risparmi 27€ (50% di sconto) · Pagamento unico
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-229" data-mp="gfimifmt5t9u">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-230" data-mp="18xe7c6x9imeb">
              <Icon className="h-4 w-4 text-grape" data-id="element-231" data-mp="146o2qvwnunko" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}